<template>
  <div class="feed-body">
    <!-- Animated Background Elements -->
    <!-- <div class="background-orbs">
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
      <div class="orb orb-3"></div>
    </div> -->

    <div class="feed-contents">
      <!-- Header Section with Stats -->
      <div class="header-section">
        <div class="header-content">
          <h1 class="main-title">
            <span class="gradient-text">Change Makers</span>
          </h1>
          <p class="subtitle">Connect with amazing volunteers in your community</p>
        </div>
        
        <!-- <div class="stats-container">
          <div class="stat-card" v-for="(stat, index) in stats" :key="index">
            <div class="stat-icon">
              <v-icon :color="stat.color">{{ stat.icon }}</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-number">{{ stat.value }}</div>
              <div class="stat-label">{{ stat.label }}</div>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Premium Tabs with Glassmorphism -->
      <div class="tabs-container">
        <div class="tabs-wrapper">
          <div 
            class="tab-button" 
            :class="{ 'active': activeTab === 'all' }"
            @click="switchTab('all')"
            @mouseenter="handleTabHover('all')"
            @mouseleave="handleTabLeave"
            data-tab="all"
          >
            <div class="tab-icon">
              <v-icon small>mdi-account-multiple</v-icon>
            </div>
            <span class="tab-text">All Volunteers</span>
            <div class="tab-count">{{ (volunteers || []).length }}</div>
          </div>
          
          <div 
            class="tab-button" 
            :class="{ 'active': activeTab === 'followers' }"
            @click="switchTab('followers')"
            @mouseenter="handleTabHover('followers')"
            @mouseleave="handleTabLeave"
            data-tab="followers"
          >
            <div class="tab-icon">
              <v-icon small>mdi-heart</v-icon>
            </div>
            <span class="tab-text">Followers</span>
           <div class="tab-count">{{ followedVolunteers.length }}</div>
          </div>
          
          <div 
            v-if="profile.type !== 'Agency'"
            class="tab-button" 
            :class="{ 'active': activeTab === 'following' }"
            @click="switchTab('following')"
            @mouseenter="handleTabHover('following')"
            @mouseleave="handleTabLeave"
            data-tab="following"
          >
            <div class="tab-icon">
              <v-icon small>mdi-account-heart</v-icon>
            </div>
            <span class="tab-text">Following</span>
            <div class="tab-count">{{ followingVolunteers.length }}</div>
          </div>
          
          <div 
            class="tab-indicator"
            :style="computedIndicatorStyle"
          ></div>
          <div 
            class="tab-glow"
            :style="computedGlowStyle"
          ></div>
        </div>
      </div>


      <!-- Enhanced Tab Content -->
      <v-fade-transition mode="out-in">
        <!-- All Volunteers -->
        <div v-if="activeTab === 'all'" key="all-volunteers" class="tab-content">
          <div class="content-header">
            <div class="filter-section">
              <v-text-field
                v-model="searchQuery"
                prepend-inner-icon="mdi-magnify"
                label="Search volunteers..."
                outlined
                dense
                hide-details
                class="search-field"
                clearable
              ></v-text-field>
              
              <!-- <v-btn
                class="filter-btn"
                icon
                @click="showFilters = !showFilters"
              >
                <v-icon>mdi-filter-variant</v-icon>
              </v-btn> -->
            </div>
          </div>
<!-- 
          <v-expand-transition>
            <div v-if="showFilters" class="filters-panel">
              <v-chip-group v-model="selectedSkills" multiple column>
                <v-chip
                  v-for="skill in availableSkills"
                  :key="skill"
                  filter
                  outlined
                  small
                  class="skill-chip"
                >
                  {{ skill }}
                </v-chip>
              </v-chip-group>
            </div>
          </v-expand-transition> -->

          <div class="volunteers-grid">
            <transition-group name="card-list" tag="div" class="card-grid">
              <div
                v-for="volunteer in filteredVolunteers"
                :key="volunteer._id"
                class="card-container"
              >
                <volunteer-card 
                  :volunteer="volunteer" 
                  class="volunteer-card-enhanced"
                  :showFollowButton="profile.type !== 'Agency'"
                />
              </div>
            </transition-group>
          </div>

          <!-- Loading State -->
          <div v-if="loading" class="loading-container">
            <div class="loading-spinner">
              <div class="spinner-ring"></div>
              <div class="spinner-ring"></div>
              <div class="spinner-ring"></div>
            </div>
            <p class="loading-text">Loading amazing volunteers...</p>
          </div>

          <!-- Empty State -->
          <div v-else-if="filteredVolunteers.length === 0" class="empty-state">
            <div class="empty-icon">
              <v-icon size="80" color="rgba(255,255,255,0.3)">mdi-account-search</v-icon>
            </div>
            <h3 class="empty-title">No volunteers found</h3>
            <p class="empty-subtitle">Try adjusting your search or filters</p>
            <v-btn
              class="cta-button"
              large
              rounded
              gradient
              @click="clearFilters"
            >
              <v-icon left>mdi-refresh</v-icon>
              Clear Filters
            </v-btn>
          </div>
        </div>

        <!-- Followers Tab -->
<!-- Followers Tab -->
<div v-else-if="activeTab === 'followers'" key="followers" class="tab-content">
  <!-- Only show cards if there are followers -->
  <div class="volunteers-grid" v-if="followedVolunteers.length > 0">
    <transition-group name="card-list" tag="div" class="card-grid">
      <div
        v-for="volunteer in followedVolunteers"
        :key="volunteer._id"
        class="card-container"
      >
        <volunteer-card 
          :volunteer="volunteer" 
          class="volunteer-card-enhanced"
          :showFollowButton="profile.type !== 'Agency'"
        />
      </div>
    </transition-group>
  </div>

  <!-- Loading State -->
  <div v-if="loadingConnections" class="loading-container">
    <div class="loading-spinner">
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
    </div>
    <p class="loading-text">Loading your connections...</p>
  </div>

  <!-- Empty State -->
  <div v-else-if="followedVolunteers.length === 0 && !loadingConnections" class="empty-state">
    <div class="empty-icon">
      <v-icon size="80" color="rgba(255,255,255,0.3)">mdi-account-heart</v-icon>
    </div>
    <h3 class="empty-title">No followers yet</h3>
    <p class="empty-subtitle">Start connecting with volunteers to build your network</p>
    <v-btn
      class="cta-button"
      large
      rounded
      gradient
      @click="switchTab('all')"
    >
      <v-icon left>mdi-account-search</v-icon>
      Explore Volunteers
    </v-btn>
  </div>
</div>

        <!-- Following Tab -->
        <div v-else-if="activeTab === 'following' && profile.type !== 'Agency'" key="following" class="tab-content">
  <div class="volunteers-grid">
    <transition-group name="card-list" tag="div" class="card-grid">
      <div
        v-for="volunteer in followingVolunteers"
        :key="volunteer._id"
        class="card-container"
      >
        <volunteer-card 
          :volunteer="volunteer" 
          class="volunteer-card-enhanced"
          :showFollowButton="profile.type !== 'Agency'"
        />
      </div>
    </transition-group>
  </div>

          <!-- Loading State -->
          <div v-if="loadingFollowing" class="loading-container">
            <div class="loading-spinner">
              <div class="spinner-ring"></div>
              <div class="spinner-ring"></div>
              <div class="spinner-ring"></div>
            </div>
            <p class="loading-text">Loading who you're following...</p>
          </div>

          <!-- Empty State -->
          <div v-else-if="followingVolunteers.length === 0" class="empty-state">
            <div class="empty-icon">
              <v-icon size="80" color="rgba(255,255,255,0.3)">mdi-account-plus</v-icon>
            </div>
            <h3 class="empty-title">Not following anyone yet</h3>
            <p class="empty-subtitle">Discover and follow amazing volunteers</p>
            <v-btn
              class="cta-button"
              large
              rounded
              gradient
              @click="switchTab('all')"
            >
              <v-icon left>mdi-compass</v-icon>
              Discover Volunteers
            </v-btn>
          </div>
        </div>
      </v-fade-transition>
    </div>

    <!-- Premium Snackbar -->
    <v-snackbar 
      v-model="snackbar" 
      :color="snackbarColor"
      shaped
      class="premium-snackbar"
    >
      <div class="snackbar-content">
        <v-icon left>{{ snackbarIcon }}</v-icon>
        {{ errorMessage }}
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import VolunteerCard from "./VolunteerCard.vue";

export default {
  components: { VolunteerCard },
  data() {
    return {
      activeTab: 'all',
      loading: false,
      loadingConnections: false,
      loadingFollowing: false,
      errorMessage: null,
      snackbar: false,
      snackbarColor: 'error',
      snackbarIcon: 'mdi-alert-circle',
      searchQuery: '',
      selectedSkills: [],
      showFilters: false,
      availableSkills: ['Web Development', 'Design', 'Marketing', 'Teaching', 'Healthcare', 'Environment']
    };
  },
  computed: {
    ...mapGetters("volunteer", {
      volunteers: "getAllVolunteers"
    }),
    ...mapState("auth", {
      profile: "profile"
    }),
    // Volunteers who follow me (Followers)
    followedVolunteers() {
      // A volunteer is a follower if their 'followed_by' includes my _id
      if (!this.volunteers || !this.profile || !this.profile._id) return [];
      const result = this.volunteers.filter(v =>
        v && v.followed_by && Array.isArray(v.followed_by) && v.followed_by.includes(this.profile._id)
      );
      console.log('Followed volunteers:', result.length, 'out of', this.volunteers.length, 'total volunteers');
      return result;
    },
    // Volunteers I am following (Following)
    followingVolunteers() {
      // I am following volunteers whose _id is in my profile.followed_by
      if (!this.volunteers || !this.profile || !this.profile.followed_by) return [];
      const result = this.volunteers.filter(v =>
        v && v._id && Array.isArray(this.profile.followed_by) && this.profile.followed_by.includes(v._id)
      );
      console.log('Following volunteers:', result.length, 'profile.followed_by:', this.profile.followed_by?.length || 0);
      return result;
    },
    stats() {
      return [
        {
          icon: 'mdi-account-group',
          value: (this.volunteers || []).length,
          label: 'Total Volunteers',
          color: '#ff6b6b'
        },
        {
          icon: 'mdi-heart',
          value: this.followedVolunteers.length,
          label: 'Followers',
          color: '#4ecdc4'
        },
        {
          icon: 'mdi-account-heart',
          value: this.followingVolunteers.length,
          label: 'Following',
          color: '#ffe66d'
        }
      ];
    },
  showFollowingTab() {
    return this.profile && this.profile.type !== 'Agency';
  },
    filteredVolunteers() {
      let filtered = this.volunteers;

      if (this.searchQuery) {
        filtered = filtered.filter(volunteer => 
          ((volunteer.first_name || '') + ' ' + (volunteer.last_name || '')).toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }

      if (this.selectedSkills.length > 0) {
        filtered = filtered.filter(volunteer =>
          volunteer.skills?.some(skill =>
            this.selectedSkills.includes(skill)
          )
        );
      }

      return filtered;
    },
    tabCount() {
      // Agency: 2 tabs, Volunteer: 3 tabs
      return this.profile.type !== 'Agency' ? 3 : 2;
    },
    tabPositions() {
      // Dynamically calculate tab positions based on visible tabs
      if (this.tabCount === 3) {
        return {
          all: '0%',
          followers: '33.33%',
          following: '66.66%'
        };
      } else {
        // Only 'all' and 'followers'
        return {
          all: '0%',
          followers: '50%'
        };
      }
    },
    computedIndicatorStyle() {
      const width = this.tabCount === 3 ? '33.33%' : '50%';
      const left = this.tabPositions[this.activeTab] || '0%';
      return {
        left,
        width,
        transform: 'translateX(0)'
      };
    },
    computedGlowStyle() {
      const width = this.tabCount === 3 ? '33.33%' : '50%';
      const left = this.tabPositions[this.activeTab] || '0%';
      return {
        left,
        width
      };
    }
  },
  methods: {
    ...mapActions("volunteer", {
      fetchAllVolunteers: "fetchAllVolunteers",
      fetchFollowedVolunteers: "fetchFollowedVolunteers",
      fetchFollowingVolunteers: "fetchFollowingVolunteers"
    }),
    switchTab(tab) {
      this.activeTab = tab;
      this.searchQuery = '';
      this.selectedSkills = [];
      this.showFilters = false;
      
      if (tab === 'followers') {
        this.loadConnections();
      } else if (tab === 'following') {
        this.loadFollowing();
      }
    },
    handleTabHover() {
      // Add subtle hover effects
    },
    handleTabLeave() {
      // Remove hover effects
    },
    clearFilters() {
      this.searchQuery = '';
      this.selectedSkills = [];
      this.showFilters = false;
    },
    loadConnections() {
      this.loadingConnections = true;
      this.fetchFollowedVolunteers()
        .then(() => {
          this.loadingConnections = false;
        })
        .catch(error => {
          this.loadingConnections = false;
          this.showErrorMessage(error.response?.data?.message || "Failed to load connections");
        });
    },
    loadFollowing() {
      this.loadingFollowing = true;
      this.fetchFollowingVolunteers()
        .then(() => {
          this.loadingFollowing = false;
        })
        .catch(error => {
          this.loadingFollowing = false;
          this.showErrorMessage(error.response?.data?.message || "Failed to load following");
        });
    },
    showErrorMessage(message) {
      this.errorMessage = message;
      this.snackbarColor = 'error';
      this.snackbarIcon = 'mdi-alert-circle';
      this.snackbar = true;
    },
    showSuccessMessage(message) {
      this.errorMessage = message;
      this.snackbarColor = 'success';
      this.snackbarIcon = 'mdi-check-circle';
      this.snackbar = true;
    }
  },
  watch: {
    '$route.query.tab'(newTab) {
      if (["all", "following", "followers"].includes(newTab)) {
        this.activeTab = newTab;
      }
    }
  },
  mounted() {
    console.log('VolunteersSection mounted - initial state:', {
      volunteers: this.volunteers?.length || 0,
      profile: this.profile?._id || 'none',
      profileFollowedBy: this.profile?.followed_by?.length || 0
    });
    
    const tabFromQuery = this.$route.query.tab;
    if (["all", "following", "followers"].includes(tabFromQuery)) {
      this.activeTab = tabFromQuery;
    }
    
    this.loading = true;
    this.fetchAllVolunteers()
      .then(() => {
        this.loading = false;
        console.log('Volunteers loaded:', this.volunteers?.length || 0);
      })
      .catch(error => {
        this.loading = false;
        this.showErrorMessage(error.response?.data?.message || "Failed to load volunteers");
      });
    
    // Only load connections and following silently in the background
    // Don't show errors for these unless user explicitly navigates to those tabs
    this.loadingConnections = true;
    this.fetchFollowedVolunteers()
      .then(() => {
        this.loadingConnections = false;
      })
      .catch(() => {
        this.loadingConnections = false;
        // Silently fail - error will be shown only when user clicks on Followers tab
      });
    
    if (this.profile.type !== 'Agency') {
      this.loadingFollowing = true;
      this.fetchFollowingVolunteers()
        .then(() => {
          this.loadingFollowing = false;
        })
        .catch(() => {
          this.loadingFollowing = false;
          // Silently fail - error will be shown only when user clicks on Following tab
        });
    }
  }
};
</script>

<style scoped>
/* Base Styles */
.feed-body {
  width: 100%;
  min-height: 100vh;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  position: relative;
  overflow-x: hidden;
}

/* Animated Background */
/* .background-orbs {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.orb {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  animation: float 6s ease-in-out infinite;
}

.orb-1 {
  width: 300px;
  height: 300px;
  top: 10%;
  left: -10%;
  animation-delay: 0s;
}

.orb-2 {
  width: 200px;
  height: 200px;
  top: 60%;
  right: -5%;
  animation-delay: 2s;
}

.orb-3 {
  width: 150px;
  height: 150px;
  bottom: 20%;
  left: 20%;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) scale(1); }
  50% { transform: translateY(-20px) scale(1.05); }
} */

.feed-contents {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

/* Header Section */
.header-section {
  margin-bottom: 40px;
  text-align: center;
}

.header-content {
  margin-bottom: 30px;
}

.main-title {
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 16px;
  line-height: 1.2;
}

.gradient-text {
  background: linear-gradient(45deg, #ff6b6b, #4ecdc4, #ffe66d, #ff6b6b);
  background-size: 300% 300%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: gradientShift 4s ease infinite;
}

@keyframes gradientShift {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
}

.stats-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.stat-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
  min-width: 150px;
}

.stat-card:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-number {
  font-size: 1.8rem;
  font-weight: 700;
  color: white;
  line-height: 1;
}

.stat-label {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

/* Premium Tabs */
.tabs-container {
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
}

.tabs-wrapper {
  position: relative;
  display: flex;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 6px;
  overflow: hidden;
}

.tab-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 24px;
  cursor: pointer;
  border-radius: 14px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: rgba(255, 255, 255, 0.7);
  font-weight: 600;
  z-index: 2;
  position: relative;
  white-space: nowrap;
  min-width: 140px;
}

.tab-button:hover {
  color: rgba(255, 255, 255, 0.9);
  transform: translateY(-1px);
}

.tab-button.active {
  color: white;
}

.tab-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-count {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 4px 8px;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 35px;
  text-align: center;
}

.tab-button.active .tab-count {
  background: rgba(255, 255, 255, 0.3);
}

.tab-indicator {
  position: absolute;
  top: 6px;
  bottom: 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
}

.tab-glow {
  position: absolute;
  top: 6px;
  bottom: 6px;
  background: linear-gradient(45deg, rgba(255, 107, 107, 0.3), rgba(78, 205, 196, 0.3));
  border-radius: 14px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 0;
  filter: blur(8px);
}

/* Content Sections */
.tab-content {
  animation: fadeInUp 0.6s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.content-header {
  margin-bottom: 30px;
}

.filter-section {
  display: flex;
  gap: 16px;
  align-items: center;
  max-width: 600px;
  margin: 0 auto;
}

.search-field {
  max-width: 600px;
  margin: 0 auto;
  background: #fff !important;
  border-radius: 23px !important;
  padding: 10px;
}


.search-field >>> .v-input__control {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-radius: 12px;
}

.search-field >>> .v-text-field__details {
  display: none;
}

.search-field >>> .v-label {
  color: #333 !important;
  transition: color 0.2s;
    padding-left: 8px !important;
  padding-right: 8px !important;
   background: transparent !important;
  z-index: 2;
}

.search-field >>> .v-label.v-label--active,
.search-field >>> .v-label.v-label--is-focused {
  color: #1976d2 !important;
  font-weight: 600;
    text-shadow: 0 1px 4px rgba(0,0,0,0.10);
  background: transparent !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  z-index: 2;
}

.filter-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.filters-panel {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 30px;
}

.skill-chip {
  margin: 4px;
  background: rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

/* Grid Layout */
.volunteers-grid {
  width: 100%;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 30px;
  width: 100%;
}

.card-container {
  display: flex;
  justify-content: center;
}

.volunteer-card-enhanced {
  width: 100%;
  max-width: 320px;
  transition: all 0.3s ease;
}

/* .volunteer-card-enhanced:hover {
  transform: translateY(-10px);
} */

/* Animations */
.card-list-enter-active,
.card-list-leave-active {
  transition: all 0.6s ease;
}

.card-list-enter-from {
  opacity: 0;
  transform: translateY(30px) scale(0.9);
}

.card-list-leave-to {
  opacity: 0;
  transform: translateY(-30px) scale(0.9);
}

.card-list-move {
  transition: transform 0.6s ease;
}

/* Loading States */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
}

.loading-spinner {
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-top: 3px solid rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

.spinner-ring:nth-child(2) {
  width: 60px;
  height: 60px;
  top: 10px;
  left: 10px;
  animation-delay: 0.3s;
  border-top-color: rgba(255, 107, 107, 0.8);
}

.spinner-ring:nth-child(3) {
  width: 40px;
  height: 40px;
  top: 20px;
  left: 20px;
  animation-delay: 0.6s;
  border-top-color: rgba(78, 205, 196, 0.8);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.1rem;
  font-weight: 500;
}

/* Empty States */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
}

.empty-icon {
  margin-bottom: 24px;
  opacity: 0.7;
}

.empty-title {
  color: white;
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 12px;
}

.empty-subtitle {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.1rem;
  margin-bottom: 32px;
  max-width: 400px;
}

.cta-button {
  background: linear-gradient(45deg, #ff6b6b, #4ecdc4) !important;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3) !important;
  transition: all 0.3s ease !important;
}

.cta-button:hover {
  transform: translateY(-3px) !important;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4) !important;
}

/* Premium Snackbar */
.premium-snackbar >>> .v-snack__wrapper {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
}

.snackbar-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .main-title {
    font-size: 2.5rem;
  }
  
  .tabs-wrapper {
    flex-direction: column;
    gap: 4px;
  }
  
  .tab-button {
    min-width: auto;
    width: 100%;
  }
  
  .tab-indicator,
  .tab-glow {
    display: none;
  }
  
  .stats-container {
    flex-direction: column;
    align-items: center;
  }
  
  .card-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .filter-section {
    flex-direction: column;
    gap: 12px;
  }
  
  .search-field {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .feed-contents {
    padding: 20px 16px;
  }
  
  .main-title {
    font-size: 2rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
  
  .stat-card {
    min-width: 120px;
    padding: 16px;
  }
  
  .stat-number {
    font-size: 1.5rem;
  }
  
  .tab-button {
    padding: 12px 16px;
    font-size: 0.9rem;
  }
  
  .empty-title {
    font-size: 1.5rem;
  }
  
  .empty-subtitle {
    font-size: 1rem;
  }
}

/* Dark Theme Enhancements */
.theme--dark .search-field >>> .v-text-field__details {
  color: rgba(255, 255, 255, 0.7);
}

.theme--dark .skill-chip >>> .v-chip__content {
  color: rgba(255, 255, 255, 0.9);
}

/* Accessibility Improvements */
.tab-button:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

.cta-button:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 4px;
}

/* Performance Optimizations */
.background-orbs {
  will-change: transform;
}

.orb {
  will-change: transform;
}

.tab-indicator,
.tab-glow {
  will-change: left, width;
}

.volunteer-card-enhanced {
  will-change: transform;
}

/* Smooth Scrolling */
.feed-body {
  scroll-behavior: smooth;
}

/* Additional Premium Effects */
.tabs-wrapper::before {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  /* background: linear-gradient(45deg, #ff6b6b, #4ecdc4, #ffe66d, #ff6b6b); */
  background-size: 400% 400%;
  border-radius: 21px;
  z-index: -1;
  opacity: 0.3;
  animation: gradientBorder 8s ease infinite;
}

@keyframes gradientBorder {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  border-radius: 16px;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.stat-card:hover::before {
  opacity: 1;
}

/* Micro-interactions */
.tab-button::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.6s ease;
  pointer-events: none;
}

.tab-button:active::after {
  width: 100px;
  height: 100px;
  opacity: 0;
}

/* Success States */
.success-message {
  background: linear-gradient(45deg, #4ecdc4, #44a08d);
  color: white;
  padding: 16px 24px;
  border-radius: 12px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  animation: slideInDown 0.5s ease;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Loading Skeleton */
.skeleton-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
}

.skeleton-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

.skeleton-line {
  height: 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  margin-bottom: 12px;
}

.skeleton-line:last-child {
  margin-bottom: 0;
  width: 60%;
}

/* Enhanced Hover Effects */
.volunteer-card-enhanced:hover {
  transform: translateY(-10px) scale(1.02);
  /* box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3); */
}

/* Pulse Animation for Active Elements */
.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

/* Glass Card Effect */
.glass-card {
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

/* Floating Action Button */
.floating-action {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 10;
  background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
}

.floating-action:hover {
  transform: translateY(-5px) scale(1.1);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4);
}

/* Print Styles */
@media print {
  .background-orbs,
  .tabs-container,
  .filter-section,
  .floating-action {
    display: none;
  }
  
  .feed-body {
    background: white;
    color: black;
  }
  
  .volunteer-card-enhanced {
    break-inside: avoid;
    margin-bottom: 20px;
  }
}
</style>